export const AGE_GROUPS = [
    {key: "U25", value: "< 25", stars: 1},
    {key: "O25U35", value: "25 - 34", stars: 2},
    {key: "O35U45", value: "35 - 44", stars: 3},
    {key: "O45U55", value: "45 - 54", stars: 4},
    {key: "O55U65", value: "55 - 64", stars: 5},
    {key: "O65", value: "> 64", stars: 6}
];

export const DEFAULT_SETUP_DATA = {
    brokerName : "",
    legal : null,
    age : null,
    gender : null,
    country : 'AUS',
    postcode : null,
    state : null,
    phone : null,
    interests : [],
    sophisticatedOrWholesale: false,
    experienceOptions: "NONE"
};


export const VALUE_BROKERS = [
    {
        sizeX: 2,
        sizeY: 1,
        row: 0,
        col: 0,
        posFeed: "daily",
        cashFeed: "daily",
        title: "Implied Volatility",
        src: "assets/img/logos/iv.png"
    },
    {
        sizeX: 2,
        sizeY: 1,
        row: 0,
        col: 2,
        posFeed: "daily",
        cashFeed: "daily",
        title: "CMC Markets",
        src: "assets/img/logos/cmc.png"
    },
    {
        sizeX: 2,
        sizeY: 1,
        row: 0,
        col: 4,
        posFeed: "daily",
        cashFeed: "daily",
        title: "CommSec",
        src: "assets/img/logos/commsec.png"
    },
    {
        sizeX: 2,
        sizeY: 1,
        row: 2,
        col: 0,
        posFeed: "daily",
        cashFeed: "daily",
        title: "Morgans",
        src: "assets/img/logos/morgans.png"
    },
    {
        sizeX: 2,
        sizeY: 1,
        row: 2,
        col: 2,
        posFeed: "daily",
        cashFeed: "daily",
        title: "Philip Capital",
        src: "assets/img/logos/PhillipCapitalAustralia.jpg"
    },
    {
        sizeX: 2,
        sizeY: 1,
        row: 2,
        col: 4,
        posFeed: "daily",
        cashFeed: "daily",
        title: "Reach Markets",
        src: "assets/img/logos/reach.png"
    }
];

export const ONLINE_BROKERS = [
    {sizeX: 2, sizeY: 1, row: 1, col: 0, title: "Implied Volatility"},
    {sizeX: 2, sizeY: 1, row: 1, col: 0, title: "Interactive Brokers"},
    {sizeX: 2, sizeY: 1, row: 2, col: 2, title: "OpenMarkets"},
    {sizeX: 2, sizeY: 1, row: 2, col: 2, title: "Commsec"},
    {sizeX: 2, sizeY: 1, row: 2, col: 2, title: "NAB"},
    {sizeX: 2, sizeY: 1, row: 2, col: 2, title: "Westpac Online"}
];

export const CONNECTED_BROKERS = [
    {sizeX: 1, sizeY: 1, row: 0, col: 0, title: "Pulse"},
    {sizeX: 1, sizeY: 1, row: 1, col: 0, title: "APP Securities"},
    {sizeX: 1, sizeY: 1, row: 0, col: 1, title: "Phillip Capital"},
    {sizeX: 1, sizeY: 1, row: 1, col: 1, title: "Morgans"},
    {sizeX: 1, sizeY: 1, row: 0, col: 3, title: "d2mx"}
];

export const OTHER_BROKERS = [
    {title: "Baillieu Holst"},
    {title: "Baker Young"},
    {title: "Bell Potter"},
    {title: "Bell Direct"},
    {title: "Burrell"},
    {title: "CognitiveWealth"},
    {title: "D2MX"},
    {title: "Evans and Partners"},
    {title: "Hartleys"},
    {title: "Macquarie"},
    {title: "Morgan Stanley WM"},
    {title: "Morrison Securities"},
    {title: "NAB"},
    {title: "Ord Minnett"},
    {title: "Paterson"},
    {title: "Pulse Markets"},
    {title: "Phillip Capital"},
    {title: "Rivkin Securities"},
    {title: "SelfWealth"},
    {title: "Sentinel"},
    {title: "Sequoia"},
    {title: "Shadforths"},
    {title: "Shaw and Partners"},
    {title: "TradersCircle"},
    {title: "UBS"},
    {title: "Vested Securities"},
    {title: "Wealthhub Securities"},
    {title: "Wilson HTM"}

];